"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevCrossHair = void 0;
const MathHelper_1 = require("../core/utils/MathHelper");
/**
 * Adds a graphical cross hair (circle with center mark) to the 0,0 position of parent.
 *
 * It also displays the position and anchor values. So when in interactive mode you can move the cross hair to see the values at any position. Very useful to set unusual anchors and so on visually.
 *
 * Usage:
 *
 *  myDisplayObject.addChild(new DevCrossHair());
 *
 * Created: 2017-06-14
 * @author jonas
 */
class DevCrossHair extends PIXI.Container {
    /**
     * Constructor
     * @param {boolean} interactive If true, the cross hair can be moved with the mouse. This is useful for visually see the position or anchor values.
     */
    constructor(interactive = false) {
        super();
        this.on("added", (container) => this.onAdded(container));
        this._interactionEnabled = interactive;
        this.init();
        console.warn("DevCrossHair is used, remove before release!");
    }
    init() {
        const alpha = 0.7;
        this._cross = new PIXI.Graphics();
        this._cross.beginFill(0x000000, 0);
        this._cross.drawRect(-10, -10, 50, 50);
        this._cross.endFill();
        this._cross.lineStyle(1, 0xFFFFFF, alpha);
        this._cross.drawCircle(0, 0, 10);
        this._cross.lineStyle(1, 0xFFFFFF, 1.0);
        this._cross.moveTo(0, 0);
        this._cross.lineTo(10, 0);
        this._cross.moveTo(0, 0);
        this._cross.lineTo(0, 10);
        this._xPos = new PIXI.Text("x: 10", DevCrossHair.DEFAULT_TEXT_STYLE);
        this._yPos = new PIXI.Text("y: 20", DevCrossHair.DEFAULT_TEXT_STYLE);
        this._xPos.position.set(12, 9);
        this._yPos.position.set(12, 9 + this._xPos.height);
        this.addChild(this._cross);
        this.addChild(this._xPos);
        this.addChild(this._yPos);
        if (this._interactionEnabled) {
            this.enableInteraction();
        }
    }
    enableInteraction() {
        this.interactive = true;
        this.buttonMode = true;
        this.on("mousedown", (event) => this.onMouseDown(event));
        this.on("mouseup", (event) => this.onMouseUp(event));
        this.on("mouseupoutside", (event) => this.onMouseUp(event));
        this.on("mousemove", (event) => this.onMouseMove(event));
    }
    onAdded(container) {
        this._target = container;
        this.updateDataOutput();
    }
    onMouseDown(event) {
        this._mouseStart = new PIXI.Point(event.data.global.x, event.data.global.y);
        this._prevPos = new PIXI.Point(this.x, this.y);
        this._move = true;
    }
    onMouseUp(event) {
        this._move = false;
        this.updateDataOutput();
    }
    onMouseMove(event) {
        if (this._move) {
            let mousePosition = event.data.global;
            let diffPos = MathHelper_1.MathHelper.subPoints(mousePosition, this._mouseStart);
            let newPos = MathHelper_1.MathHelper.addPoints(this._prevPos, diffPos);
            this.position.set(newPos.x, newPos.y);
        }
        this.updateDataOutput();
    }
    updateDataOutput() {
        let xAnchor = this.x / this._target.width;
        let yAnchor = this.y / this._target.height;
        this._xPos.text = "x: " + this.x + " (" + xAnchor.toFixed(3) + ")";
        this._yPos.text = "y: " + this.y + " (" + yAnchor.toFixed(3) + ")";
        if (this.updateCallback) {
            this.updateCallback(new PIXI.Point(this.x, this.y), new PIXI.Point(xAnchor, yAnchor));
        }
    }
}
DevCrossHair.DEFAULT_TEXT_STYLE = {
    fontFamily: "Lucida Console",
    fontSize: 12,
    fill: 0xFFFFFF
};
exports.DevCrossHair = DevCrossHair;
//# sourceMappingURL=DevCrossHair.js.map